import { USER_SETTINGS_QUERY_KEY } from '../hooks/queries/keys'
import { initialUserSettings } from './constants'

export function getDefaultProjectIdFromCache(queryClient) {
  const userSettings = queryClient.getQueryData(USER_SETTINGS_QUERY_KEY) ?? initialUserSettings
  return userSettings?.defaultProjectId ?? null
}
